import { render } from "./ParceiroForm.vue?vue&type=template&id=d8705bcc"
import script from "./ParceiroForm.vue?vue&type=script&lang=js"
export * from "./ParceiroForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__